<template>
  <div>
    <van-nav-bar title="微考勤" left-text=""/>
    <van-overlay :show="show" >
      <div class="wrapper">
        <van-loading color="#0094ff" >系统自动登录中...</van-loading>
      </div>
    </van-overlay>
<!--    <van-row>-->
<!--      <van-col span="5"></van-col>-->
<!--      <van-col span="14">-->
<!--        <van-image src="/static/images/logo-3.png"/>-->
<!--      </van-col>-->
<!--      <van-col span="5"></van-col>-->
<!--    </van-row>-->
<!--    <van-form @submit="login" class="login-form-top">-->
<!--      <van-field-->
<!--        v-model="account"-->
<!--        name="工号"-->
<!--        label="工号"-->
<!--        placeholder="工号"-->
<!--        :rules="[{ required: true, message: '请填写工号' }]"-->
<!--      />-->
<!--      <van-field-->
<!--        v-model="password"-->
<!--        type="password"-->
<!--        name="密码"-->
<!--        label="密码"-->
<!--        placeholder="密码"-->
<!--        :rules="[{ required: true, message: '请填写密码' }]"-->
<!--      />-->
<!--      <div style="margin: 16px;">-->
<!--        <van-button round block type="info" native-type="submit">登录</van-button>-->
<!--      </div>-->
<!--    </van-form>-->
  </div>
</template>

<script>

import {Toast} from "vant";
import {isWechat} from "../utils/util";

export default {
  name: "login",
  data() {
    return {
      account: "",
      password: "",
      tenantId: "000000",
      checked: false,
      grantType: 'password',
      scope: 'all',
      type: 'account',
      code: '',
      show: true,
    };
  },
  mounted() {
    if(!isWechat()){
      this.$router.push({
        path: "/attenceflow/Error",
        query: {
        }
      });
    }
    localStorage.removeItem('token');
    this.code = this.getQueryString("code");
    this.$fetch("/attence-api/blade-auth/wxWorkLogin", {
      code: this.code
    }).then(
      res => {
        const data = res.data;
        this.$post("/attence-api/blade-auth/wxToken", {account: data.account, password: data.password}).then(
          res => {
            if (res.hasOwnProperty("error_code")) {
              this.password = '';
              Toast.fail(res.error_description);
            } else {
              const userData = res.data;
              if (userData.hasOwnProperty("access_token")) {
                localStorage.setItem("token", userData.access_token);
                this.$router.push({
                  path: "/attenceflow/AttenceHome",
                  query: {
                    userId: userData.user_id
                  }
                });
              } else {
                Toast.fail("接口异常，请联系管理员！");
              }
            }
            console.log("返回的数据：" + JSON.stringify(res));
          },
          error => {
            this.show = false;
          }
        );
        console.log("返回的用户数据：" + JSON.stringify(data));

      },
      error => {
        this.show = false;
      }
    );
  },
  methods: {
    getQueryString: function (name) {
      const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
      const result = window.location.search.substring(1).match(reg);
      if (result != null) {
        return decodeURIComponent(result[2]);
      }
      return null;
    },
    login: function () {
      let mw_pass = this.password;
      this.password = this.$md5(this.password);
      this.$post("/attence-api/blade-auth/oauth/token", {
        username: this.account,
        password: this.password,
        tenantId: this.tenantId,
        grant_type: this.grantType,
        mw_pass: mw_pass,
        scope: this.scope,
        type: this.type
      }).then(
        res => {
          if (res.hasOwnProperty("error_code")) {
            this.password = '';
            Toast.fail(res.error_description);
          } else {
            const data = res;
            if (data.hasOwnProperty("access_token")) {
              localStorage.setItem("token", data.access_token);
              this.$router.push({
                path: "/attenceflow/AttenceHome",
                query: {
                  userId: data.user_id
                }
              });
            } else {
              Toast.fail("接口异常，请联系管理员！");
            }
          }
          console.log("返回的数据：" + JSON.stringify(res));
        },
        error => {
        }
      );
    },
  }
}
</script>

<style scoped>
.van-nav-bar {
  background-color: #2196f3;
}

/deep/ .van-nav-bar__title {
  color: #fff;
}

/deep/ .van-nav-bar__text {
  color: #fff;
}

.login-form-top {
  margin-top: 0px;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue